/**
 * 房屋面积相关的小工具函数
 *
 * 约定：
 * - 仅在“有至少一个输入值存在”时返回计算结果
 * - 缺失值按 0 参与计算
 * - 两个值都缺失时返回 undefined（用于避免无意覆盖用户手填的总面积）
 */
export function toNumberOrUndefined(value: unknown): number | undefined {
  if (value === null || value === undefined) return undefined;
  if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return undefined;
    const n = Number(trimmed);
    return Number.isFinite(n) ? n : undefined;
  }
  return undefined;
}

import { decimalAdd, decimalSub } from './decimalMath';

export function calcBuildingAreaFromInnerAndShared(
  innerArea: unknown,
  sharedBuildingArea: unknown
): number | undefined {
  const sum = decimalAdd(innerArea, sharedBuildingArea);
  if (sum === undefined) return undefined;
  const n = Number(sum);
  return Number.isFinite(n) ? n : undefined;
}

/**
 * 在“建筑面积固定不动”的前提下：
 * - 用户修改套内面积：自动计算分摊建筑面积 = 建筑面积 - 套内面积
 * - 用户修改分摊建筑面积：自动计算套内面积 = 建筑面积 - 分摊建筑面积
 *
 * 只有当 buildingArea 有值，且被修改的那一项有值时才计算；
 * buildingArea 为空时不做联动，避免误填。
 */
export function calcSharedBuildingAreaFromBuildingAndInner(
  buildingArea: unknown,
  innerArea: unknown
): number | undefined {
  const diff = decimalSub(buildingArea, innerArea);
  if (diff === undefined) return undefined;
  const n = Number(diff);
  return Number.isFinite(n) ? n : undefined;
}

export function calcInnerAreaFromBuildingAndShared(
  buildingArea: unknown,
  sharedBuildingArea: unknown
): number | undefined {
  const diff = decimalSub(buildingArea, sharedBuildingArea);
  if (diff === undefined) return undefined;
  const n = Number(diff);
  return Number.isFinite(n) ? n : undefined;
}


